import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useAppDispatch, useAppSelector } from 'helpers/redux';
import { RootState } from 'app/store';

import PoleStatusForm from '../components/PoleStatusForm';
import { InputModel, PoleStatus } from '../models';
import { HttpClientError, RequestStatus } from 'http-client';
import {
    createPoleStatus, getList,
    reset,
    updatePoleStatus,
} from '../poleStatus.reducer';
import {savedStatusOption} from "../../../../helpers/alertLabel";

const PoleStatusDetailPage = ({
    isEdit = false, ...props
}: PoleStatusDetailPageProps) => {
    const dispatch = useAppDispatch();
    const MySwal = withReactContent(Swal);

    const isLoading = useAppSelector(
        (state: RootState) => state.poleStatus.isLoading ?? false
    );
    const singleState = useAppSelector(
        (state: RootState) => state.poleStatus.single ?? ({} as PoleStatus)
    );
    const status = useAppSelector((state: RootState) => state.poleStatus.status);
    const error = useAppSelector(
        (state: RootState) => state.poleStatus.error ?? ({} as HttpClientError)
    );

    const onSubmit = (formInput: InputModel) => {
        if (isEdit) {
            let _formInput = { ...formInput, id: singleState.id };
            dispatch(updatePoleStatus(_formInput));
        } else {
            dispatch(createPoleStatus(formInput));
        }
        dispatch(reset());
    };

    useEffect(() => {
        if (status !== undefined && status !== RequestStatus.pending) {
            MySwal.fire(savedStatusOption(status === RequestStatus.success, error.data?.message)).then(() => {
                dispatch(reset());
                dispatch(getList({ skip: 0, take: 10 }));
                props.toggleModal();
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status, error]);

    return (
        <div className="p-2 md:p-6 pt-2 md:pt-2 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-2xl">
            <PoleStatusForm
                isLoading={isLoading}
                isEdit={isEdit}
                onSubmit={onSubmit}
            />
        </div>
    );
};

export interface PoleStatusDetailPageProps {
    isEdit: boolean;
    toggleModal: () => void;
}

export default PoleStatusDetailPage;
